<nav class="navbar navbar-expand-lg bg-info navbar-dark menu">
  <div class="container">
    <a class="navbar-brand" href="#">FLSHM</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link"  [routerLink]="['/cp']">Avis <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/cpslide']">Slide</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/cpublication']">Publication</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/cpagination']">Pagination</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/cpstat']">Statistiques</a>
        </li>
        <li class="nav-item" *ngIf="afficheMenuUser">
          <a class="nav-link" [routerLink]="['/cpuser']">Users</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/cpvideo']">video</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/notif']">Notification</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" (click)="logout()">LogOut</a>
        </li>

      </ul>
    </div>
  </div>
</nav>
